import React from "react";

const Footer = () => {
  return (
    <div
      className="footer"
      style={{
        padding: "2.5rem",
        textAlign: "center",
        color: "#8B95A1",
        fontSize: "1.6rem",
      }}
    >
      Made by Vugar - 2021
    </div>
  );
};

export default Footer;
